<template>
  <!-- D: 모달은 .l-wrap 바깥에 넣어주세요. -->
  <!-- D: 퍼블에서는 hidden 클래스넣지만 개발에서는 동적으로 불러와야할 듯합니다 -->
  <div id="CYB_PC_LO_01_02" class="modal" data-popup>
    <div class="dialog">
      <header class="dialog-header">
        <h2 class="dialog-title">
          3개월마다 비밀번호를 <br class="is-mo" />
          변경해 주세요
        </h2>
        <button type="button" class="dialog-close" data-popup-close>
          <span class="c-icon icon-large-x"></span>
          <span class="sr-only">팝업 닫기</span>
        </button>
      </header>

      <div class="dialog-content">
        <div class="dialog-content-inner">
          <div class="c-round-box">
            <strong class="subject"
              >안전한 서비스 이용을 위해
              <span class="color-primary">3개월마다 비밀번호 변경</span>이
              필요합니다.
            </strong>
            <ul class="c-dot-list type-small">
              <li>새 비밀번호는 기존 비밀번호와 다른 것으로 설정해 주세요.</li>
              <li>
                보안을 위해 띄어쓰기 없는 영문, 숫자, 특수문자 포함 8~15자로
                설정해주세요.
              </li>
            </ul>
          </div>
          <form class="form-wrap">
            <div class="c-form-field">
              <label class="c-input-label-group type-password">
                <input type="password" required title="새로운 비밀번호" />
                <span class="input-label">새로운 비밀번호</span>
                <span class="input-helper"
                  >띄어쓰기 없는 영문, 숫자, 특수문자 (!@#$%^*+=-) 포함
                  8~15자</span
                >
                <button type="button" class="c-btn-icon btn-eye">
                  <i class="c-icon icon-eye"></i>
                </button>
                <button type="button" class="c-btn-icon btn-small-delete">
                  <span class="c-icon icon-small-x"></span>
                </button>
              </label>
            </div>
            <div class="c-form-field">
              <label class="c-input-label-group type-password">
                <input type="password" required title="비밀번호 확인" />
                <span class="input-label">비밀번호 확인</span>
                <button type="button" class="c-btn-icon btn-eye">
                  <i class="c-icon icon-eye"></i>
                </button>
                <button type="button" class="c-btn-icon btn-small-delete">
                  <span class="c-icon icon-small-x"></span>
                </button>
              </label>
            </div>
          </form>
        </div>
      </div>

      <div class="dialog-footer">
        <div class="c-checkbox">
          <input type="checkbox" id="chk1" name="chkgroup" />
          <label for="chk1">3개월간 보지 않기</label>
        </div>
        <div class="c-btn-area">
          <button type="button" class="c-button type-secondary">
            <span class="is-pc">나중에 변경하기</span>
            <span class="is-mo">나중에 변경</span>
          </button>
          <button type="button" class="c-button type-primary">
            <span class="is-pc">비밀번호 변경하기</span>
            <span class="is-mo">비밀번호 변경</span>
          </button>
        </div>
      </div>
    </div>
    <!-- D: dimmed -->
    <div class="dimmed"></div>
  </div>
</template>
<script setup name="passChangeInstPop"></script>
